import {ProprietarioObject} from "../../models/Proprietario";
import {useEffect, useState} from "react";
import fb from "../firebase";
import {FazendaObject} from "../../models/Fazenda";
import {useFirestore, UseFirestoreOptions, useFirestoreSnap} from "./useFirestore";
import firebase from "firebase/compat/app";


export const useFazendas = (args: {userId: string}, options?: UseFirestoreOptions): [FazendaObject[], boolean] => {
  const {userId} = args;

  return useFirestore<FazendaObject>({
    queryKey: `useFazendas:${userId}`,
    query: () => fb.db.collection('fazendas')
      .where('owner', '==', userId)
      .orderBy('nome', 'asc'),
    options,
  });
}

export const useFazendasProprietario = (args: {userId: string, proprietario: ProprietarioObject}, options?: UseFirestoreOptions): [FazendaObject[], boolean] => {
  const {userId, proprietario} = args;
  const {path} = proprietario;

  return useFirestore<FazendaObject>({
    queryKey: `useFazendasProprietario:${userId}:${path}`,
    query: () => fb.db.collection('fazendas')
      .where('owner', '==', userId)
      .where('_proprietario', '==', fb.db.doc(path))
      .orderBy('nome', 'asc'),
    options,
  });
}

export const useCountFazendasProprietarioUser = (userId: string, proprietario: ProprietarioObject): [number|undefined, boolean] => {
  const [isLoading, setIsLoading] = useState(false);
  const [numFazendas, setNumFazendas] = useState<number>();
  const {path} = proprietario;

  if (!path)
    throw new Error('Proprietario sem path');

  useEffect(() => {
    setIsLoading(true);
    const query = fb.db.collection('fazendas')
      .where('owner', '==', userId)
      .where('_proprietario', '==', fb.db.doc(path));

    return query.onSnapshot(snap => {
      setIsLoading(false);
      setNumFazendas(snap.size);
    });
  }, [userId, path]);

  return [numFazendas, isLoading];
}


export interface FazendaIndexProprietario {
  [key: string]: string[];
}

export const useFazendasIndexProprietarios = (args: {userId: string}, options?: UseFirestoreOptions): [FazendaIndexProprietario, boolean] => {
  const {userId} = args;
  const [indexProps, setIndexProps] = useState({} as FazendaIndexProprietario);
  const [isLoading, setIsLoading] = useState(false);

  const [_snap, _isLoading] = useFirestoreSnap({
    queryKey: `useFazendas:${userId}`,
    query: () => fb.db.collection('fazendas')
      .where('owner', '==', userId)
      .orderBy('nome', 'asc'),
    options,
  });

  useEffect(() => {
    setIsLoading(_isLoading);

    if (!_snap || _isLoading)
      return;

    const _indexProps = {} as FazendaIndexProprietario;
    _snap.forEach(doc => {
      const _proprietario = doc.get('_proprietario') as firebase.firestore.DocumentReference;
      const _proprietarioId = _proprietario.id;
      if (!_indexProps[_proprietarioId])
        _indexProps[_proprietarioId] = [];
      _indexProps[_proprietarioId].push(doc.id);
    });
    setIndexProps(_indexProps);
    // console.log('useFazendasIndexProprietarios', _indexProps);
  }, [_snap, _isLoading]);

  return [indexProps, isLoading];
};